module.exports = __webpack_public_path__ + "static/media/294504.74b345b1.png";